module.exports = __webpack_public_path__ + "static/media/view1.4a63e635.jpg";